import __base_store from '@/store/__base_store'

/**
 * Store de cajas (modelo `caja`).
 * Construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'caja',
	},
})

